var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    [
      _vm.items
        ? _c("paginate", {
            attrs: {
              "click-handler": _vm.clickHandler,
              "page-count": _vm.items.last_page,
              "page-range": 3,
              "margin-pages": 2,
              "prev-text": "&laquo",
              "next-text": "&raquo",
              "container-class": "pagination",
              "prev-class": "page-item",
              "prev-link-class": "page-link",
              "page-class": "page-item",
              "page-link-class": "page-link",
              "next-class": "page-item",
              "next-link-class": "page-link",
              "active-class": "active green_btn",
            },
          })
        : _vm._e(),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }